$(document).ready(function() {
  $('.price-unit-select-dependee').change(changePriceUnitVisibility)
})

function changePriceUnitVisibility() {
  if ($('.price-unit-select-dependee').val() === "price") {
    $('.price-unit-select').show()
  } else {
    $('.price-unit-select').hide()
  }
}
